__turbopack_context__.v({
  "container": "styles-module__Zu29aW__container",
  "fade": "styles-module__Zu29aW__fade",
});
